var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #A7D379;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M804.32,672.4l-69.28-69.28c-19.1-19.1-50.18-19.1-69.28,0l-31.49,31.49c-14.47,14.47-38.02,14.47-52.48,0l-136.5-136.61c-14.5-14.5-14.51-37.98,0-52.49,5.07-5.07,19.64-19.64,31.49-31.49,19.02-19.02,19.28-50-.02-69.3l-69.26-69.05c-19.1-19.1-50.18-19.1-69.23-.05-14.25,14.13-18.85,18.69-25.24,25.03-68.88,68.88-68.88,180.95,0,249.83l216.28,216.39c69.04,69.04,180.79,69.05,249.83,0l25.19-25.19c19.1-19.1,19.1-50.18,0-69.28ZM711.94,626.21l69.28,69.28c6.37,6.37,6.37,16.73,0,23.09l-11.55,11.55-92.37-92.38,11.55-11.55c6.37-6.37,16.73-6.37,23.09,0ZM384.42,298.79l69.26,69.05c6.38,6.38,6.38,16.71,0,23.09l-11.55,11.55-92.32-92.32,11.49-11.39c6.37-6.37,16.72-6.37,23.11.02ZM552.39,743.78l-216.28-216.39c-53.29-53.29-56.22-136.97-9.01-193.76l92.05,92.05c-24.19,27.42-23.18,69.2,3.03,95.41l136.5,136.61s0,0,0,0c26.18,26.19,67.96,27.26,95.41,3.04l92.05,92.05c-56.61,47.13-140.1,44.65-193.76-9.01Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.30cbb75372337478efae721dd61bfe7c.svg";
export { ForwardRef as ReactComponent };